/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Progress_Report_Exercise_OpenInputs */

const en_us2_progress_report_exercise_open = /** @type {(inputs: Progress_Report_Exercise_OpenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Open ${i?.name}`)
};

const pt_br2_progress_report_exercise_open = /** @type {(inputs: Progress_Report_Exercise_OpenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Abrir ${i?.name}`)
};

const es_419_progress_report_exercise_open = /** @type {(inputs: Progress_Report_Exercise_OpenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Abrir ${i?.name}`)
};

const pt_pt2_progress_report_exercise_open = /** @type {(inputs: Progress_Report_Exercise_OpenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Abrir ${i?.name}`)
};

const fr_fr2_progress_report_exercise_open = /** @type {(inputs: Progress_Report_Exercise_OpenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ouvrir ${i?.name}`)
};

const de_de2_progress_report_exercise_open = /** @type {(inputs: Progress_Report_Exercise_OpenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} öffnen`)
};

const it_it2_progress_report_exercise_open = /** @type {(inputs: Progress_Report_Exercise_OpenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Apri ${i?.name}`)
};

/**
* | output |
* | --- |
* | "Open {name}" |
*
* @param {Progress_Report_Exercise_OpenInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_report_exercise_open = /** @type {((inputs: Progress_Report_Exercise_OpenInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Report_Exercise_OpenInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_report_exercise_open(inputs)
	if (locale === "es-419") return es_419_progress_report_exercise_open(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_report_exercise_open(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_report_exercise_open(inputs)
	if (locale === "de-DE") return de_de2_progress_report_exercise_open(inputs)
	if (locale === "it-IT") return it_it2_progress_report_exercise_open(inputs)
	return en_us2_progress_report_exercise_open(inputs)
});
export { progress_report_exercise_open as "progress-report.exercise_open" }